/**
 * Formats a document ID into an array of formatted strings.
 *
 * @param documentId - The document ID to format (e.g., "folder/sub-folder/document-name")
 * @returns An array of formatted strings, where each string is:
 *   - Split by '/'
 *   - Dashes converted to spaces
 *   - Title cased (first letter of each word capitalized)
 *
 * @example
 * formatDocumentName("folder/sub-folder/my-document")
 * // Returns: ["Folder", "Sub Folder", "My Document"]
 */
export function formatDocumentName(documentId: string): string[] {
  if (!documentId) {
    return [];
  }

  return documentId
    .split('/')
    .filter((part) => part.length > 0) // Remove empty parts
    .map((part) => {
      // Convert dashes to spaces
      const withSpaces = part.replace(/-/g, ' ');

      // Title case: capitalize first letter of each word
      return withSpaces
        .split(' ')
        .map((word) => {
          if (word.length === 0) return word;

          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
    });
}
